import { getAltaDomain, validDevelopmentUrlRegEx } from 'utils/domains';
import { getWindowLocation } from 'utils/window';

/**
 * @returns the app origin url for the current env
 */
export const getAppOrigin = (appName: string) => {
  const { origin } = getWindowLocation();

  // local development
  if (validDevelopmentUrlRegEx.test(origin)) {
    return `${origin}/${appName}`;
  }

  // for deployed envs
  const domain = getAltaDomain();

  return domain ? `https://${appName}.${domain}` : '';
};
